export default {
  page_title: 'HKLII 简介',
  t_whatis: "什么是 HKLII?",
  t_personnel: '成员',
  t_assist: '对 HKLII 的支援',
  intro: [
    '{0}(HKLII，读音为 “H K Lee”) 是由香港大学{1}与香港大学{2}在Australasian Legal Information Institute ({3}) 的协助下共同开发及营运的免费法律资讯系统。',
    'HKLII 旨在透过易于使用且涵盖范围广泛的技术，使大众能够获取免费的第一手法律资讯 (以及一些给予公众查阅的二手资讯)。HKLII 支持并参与法律信息自由取用运动。',
    'HKLII 提供的资讯来自香港和有关地区。标记及其他技术基础结构均由AustLII提供的软件而调整。World Law Index 下的香港、中国和台湾页面（以及某些主题页面）是由香港大学法律学院和 AustLII 共同编写。 HKLII 整个项目及日常运作由法律学院管理及负责。',
    '我们希望能为阁下提供有用的法律资讯，亦希望阁下会喜欢使用 HKLII 系统。我们欢迎阁下提供任何鼓励或建设性批评。',
  ],
  cs_dept: '计算器科学系',
  law_fac: '法律学院',
  law_fac2: '香港大学法律学院',
  addr_tag: '邮件地址',
  addr: '香港法律资讯中心<br>香港薄扶林道<br>香港大学百周年校园<br>郑裕彤教学楼10楼<br>',
  email_tag: '电邮',
  email: '请直接于{0}页面与我们联系',
  website_tag: '网址',
  personnel: [
    'HKLII 为{3}{0}和香港大学{1}共同成立的{2}的一个研究项目，由法律学院管理，成立初时亦得到 {4} (AustLII) 的协助。',
    '如阁下对 HKLII 有任何意见或疑问，欢迎于{0}页面与我们联系。'
  ],
  law_and_tech: '资讯科技及法律研究中心',
  uni: '香港大学',
  management_tag: '管理团队',
  staff_tag: '职员',
  former_staff_tag: '前职员',
  providers_tag: '资料提供者',
  providers: [
    'HKLII 的资料库包含以下资料来源:',
    'HKLII 衷心感谢所有资料提供者。各资料库页面上均有注明来源。',
  ],
  provider_ents: [
    '香港特别行政区司法机构',
    '香港特别行政区律政司',
    '香港国际仲裁中心',
    '香港大学吕志和法律图书馆',
    '香港大学法律学院比较法及公法研究中心'
  ],
  grants_tag: '赠款',
  grants: [
    'HKLII 的成立和初期系统维护由香港大学计算器科学系和香港大学法律学院负责，并得到 Australasian Legal Information Institute (AustLII) 的协助及赠款，才得以为大众提供更多普通法及亚太地区的法律资讯。',
    '我们欢迎阁下查询有关 HKLII 的赞助和资源。请参阅{0}和{1}页面以获取联络方法。',
  ],
  thanks_tag: '鸣谢',
  thanks: [
    'HKLII 的成立有赖不同人士的协助和支持，特别是香港特别行政区司法机构及香港特别行政区律政司的人员。由于人数众多，无法在此一一列出，HKLII 仅此对他们表示衷心谢意。'
  ]
}